export const jobTypeOptions = ['full-time', 'part-time', 'remote', 'internship'];

export const statusOptions = ['pending', 'interview', 'declined'];
